<div class="modal-header">
    <h4 class="modal-title roboTitle" id="modal-basic-title">{{'invoices.edit.entities.other.additional_ibans' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="padding: 10px">
    <div style="margin: 0;margin-top: 5px;overflow-x: auto;">
        <table class="table" *ngIf="ibans && ibans.length > 0">
            <thead>
                <tr>
                    <th scope="col">{{'invoices.edit.entities.other.select_an_iban' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let iban of ibans; index as i"  style="cursor: pointer;" (click)="save(i)">
                    <td>
                        <h5>{{iban}}</h5>
                    </td>
                </tr>
            </tbody>    
        </table>
        <ng-container *ngIf="ibans && ibans.length == 0 && !loading">
            <ngb-toast [autohide]="false" class="warning">
                <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                {{'general.noAdditionalIbans' | translate}}
            </ngb-toast>
        </ng-container>
        <app-loading *ngIf="loading"></app-loading>
    </div>

</div>
